import {getActionablePartFormQualificationForms} from "../hooks/use-part-form-qualification";

/**
 * Merges actionable forms across multiple parts so each formId appears once,
 * with the list of part labels that still require that form.
 *
 * @param {Array<{ partLabel?: string, forms?: import("../../../../core/services/api/type-declerations/response").PartFormQualificationFormDs[] }>} entries
 * @returns {Array<import("../../../../core/services/api/type-declerations/response").PartFormQualificationFormDs & { awaitingPartLabels: string[] }>}
 */
export function mergePartFormComplianceForms(entries) {
    /** @type {Map<string, import("../../../../core/services/api/type-declerations/response").PartFormQualificationFormDs & { awaitingPartLabels: string[] }>} */
    const byFormId = new Map();

    for (const entry of entries ?? []) {
        const partLabel = entry.partLabel?.trim();
        for (const form of getActionablePartFormQualificationForms(entry.forms)) {
            const existing = byFormId.get(form.formId);
            if (existing) {
                if (partLabel && !existing.awaitingPartLabels.includes(partLabel)) {
                    existing.awaitingPartLabels.push(partLabel);
                }
            } else {
                byFormId.set(form.formId, {
                    ...form,
                    awaitingPartLabels: partLabel ? [partLabel] : [],
                });
            }
        }
    }

    const merged = [...byFormId.values()];
    merged.sort((a, b) => (a.formTitle ?? "").localeCompare(b.formTitle ?? ""));
    return merged;
}
